export default function HamburgerMenu () {
  const HAMBURGER_ICON = document.querySelector('#big-hamburger-menu')
  const HAMBURGER_MENU = document.querySelector('.mtt-big-menu')

  if (HAMBURGER_ICON && HAMBURGER_MENU) {
    const MENU = new MegaMenu(HAMBURGER_ICON, HAMBURGER_MENU)
    MENU.init()
  }
}

class MegaMenu {
  constructor (icon, menu) {
    this.icon = icon
    this.menu = menu

    this.init = () => {
      this.onIconClick()
      this.onMenuItemHover()
      this.closeOnEscape()
    }
  }

  onIconClick () {
    this.icon.addEventListener('click', () => {
      this.toggleMenu()
    })
  }

  toggleMenu () {
    document.body.classList.toggle('big-menu-open')
    this.icon.classList.toggle('open')
    this.menu.classList.toggle('open')
    document.querySelector('.mtt-header').classList.toggle('big-menu-open')
  }

  onMenuItemHover () {
    const ITEMS = this.menu.querySelectorAll('.menu-item')

    if (ITEMS.length) {
      for (let i = 0; i < ITEMS.length; i++) {
        const ITEM = ITEMS[i]

        ITEM.addEventListener('mouseover', () => {
          if (!ITEM.classList.contains('active')) {
            this.showItemImage(ITEM)
          }
        })
      }
    }
  }

  showItemImage (item) {
    const IMAGES_WRAPPER = this.menu.querySelector('.mtt-big-menu__image-wrapper')
    const MATCHING_CLASS = item.classList[3]
    let CORRECT_IMAGE_WRAPPER = ''

    if (MATCHING_CLASS) {
      CORRECT_IMAGE_WRAPPER = IMAGES_WRAPPER.querySelector('.' + MATCHING_CLASS)
    }

    if (CORRECT_IMAGE_WRAPPER) {
      const CORRECT_IMAGE = CORRECT_IMAGE_WRAPPER.querySelector('img')
      IMAGES_WRAPPER.querySelector('.active').classList.remove('active')

      if (!CORRECT_IMAGE.hasAttribute('src')) {
        CORRECT_IMAGE.setAttribute('src', CORRECT_IMAGE.getAttribute('data-img-src'))
      }

      CORRECT_IMAGE_WRAPPER.classList.add('active')
    }
  }

  closeOnEscape () {
    window.addEventListener('keydown', (e) => {
        if (this.menu.classList.contains('open')) {
          if (e.key === 'Escape') {
            this.toggleMenu()
          }
        }
      }
    )
  }
}
